import React from 'react';
import { createIcon } from '@chakra-ui/react';

const LocationIcon = createIcon({
  displayName: 'LocationIcon',
  viewBox: '0 0 14 16',
  path: (
    <path
      d='M7 14.7223C7 14.7223 12.5 11.0556 12.5 6.77783C12.5 5.31914 11.9205 3.92019 10.8891 2.88874C9.85764 1.85729 8.45869 1.27783 7 1.27783C5.54131 1.27783 4.14236 1.85729 3.11091 2.88874C2.07946 3.92019 1.5 5.31914 1.5 6.77783C1.5 9.40027 3.56698 11.793 5.16667 13.2522M7 8.61117C8.01252 8.61117 8.83333 7.79035 8.83333 6.77783C8.83333 5.76531 8.01252 4.9445 7 4.9445C5.98748 4.9445 5.16667 5.76531 5.16667 6.77783C5.16667 7.15267 5.27916 7.50123 5.47222 7.7916'
      stroke='currentColor'
      fill='transparent'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ),
});

export default LocationIcon;
